__turbopack_context__.v({
  "logo": "styles-module-scss-module__RpQ_SG__logo",
});
